// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__TzQrQ","legacyBtn":"MutateMid_legacyBtn__PbNA_"};